import { shape, string } from 'prop-types';

const commentShape = shape({
  author: shape({
    name: string,
    email: string,
  }),
  text: string,
  createdAt: string,
  eventId: string,
  commentId: string,
});

export default commentShape;
